import React, { Fragment, useEffect, useState, useCallback } from 'react';

import { api, Auth } from '../api';
import { ListGroup } from 'react-bootstrap';
import { ItemReviewListItem } from './ItemReview';
import { NavLink } from 'react-router-dom';
import { getCloudinaryUrlFromKey } from './Helpers';
import { S3ImageUpload } from './ImageUploader';

function userReviewListItem(review, editable) {
    return (
        <ListGroup.Item key={review.id} style={{display: "inline-block", paddingLeft: "0px", paddingRight: "0px", paddingBottom: "0px", marginBottom: "48px"}}>
            <ItemReviewListItem review={review} editable={editable} showItemLink={true} showUserLink={false} showVendorLink={true} showVendorMap={true} showFullReview={false}/>
        </ListGroup.Item>
    );
}

function UserItemReviewListItems(props) {
    if(!props.user.reviews) {
        return <Fragment></Fragment>;
    }
    return props.user.reviews.map(function(review) {
        return userReviewListItem(review, props.editable);
    });
}

function ItemReviewWithUserListItems(props) {
    if(!props.itemReviews) {
        return <Fragment></Fragment>;
    }
    return props.itemReviews.map(function(review) {
        return userReviewListItem(review, props.editable);
    });
}


function FavItem(props) {
    if(!props.favItem) {
        return <Fragment></Fragment>;
    }
    return (
        <div className="headerTextLight" style={{display: "inline-block", marginRight: "12px"}}>Favorite Doughnut: <NavLink to={`/d/${props.favItem.id}`}>{props.favItem.name}</NavLink></div>
    );
}

function FavShop(props) {
    if(!props.favVendor) {
        return <Fragment></Fragment>;
    }
    return (
        <div className="headerTextLight"  style={{display: "inline-block"}}>Favorite Shop: <NavLink to={`/v/${props.favVendor.id}`}>{props.favVendor.name}</NavLink></div>
    );
}

function JoinDate(props) {
    if(props.joinDate) {
        var date = new Date(props.joinDate);
        return "Joined " + date.getFullYear();
    }
    else {
        return "";
    }
}

function UserHeader(props) {
    return (
        <div style={{ padding: "24px 12px 24px 12px", marginTop: "100px", marginBottom: "0px" }}>
            <ProfilePhotoLoader photo={props.user.photo}
                userId={props.user.id}
                editable={props.editable}
                size="108"/>
            <div style={{display: "inline-block", marginLeft: "12px"}}>
                <div style={{display: "inline-block"}}>
                    <h1 style={{display: "inline-block"}}>{props.user.name}</h1>
                </div>
                <p className="headerTextLight"><JoinDate joinDate={props.user.joinDate} /></p>
            </div>
            <br></br>
            <br></br>
            <div style={{display: (props.showFavs) ? "inline" : "none"}}>
                <FavItem favItem={props.user.favItem} />
                <FavShop favVendor={props.user.favVendor} />
            </div>
        </div>
    );
}

function UserReviewsHeader() {
    return (
        <h1>Reviews</h1>
    );
}

function UserReviews(props) {
    return (
        <ListGroup style={{maxWidth: "1002px"}}>
            <UserItemReviewListItems user={props.user} editable={props.editable}></UserItemReviewListItems>
        </ListGroup>
    );
}

class User extends React.Component {
    render() {
        return (
            <div style={{}}>
                <UserHeader user={this.props.user} showFavs={true} editable={this.props.editable} />
                <UserReviewsHeader />
                <UserReviews user={this.props.user} editable={this.props.editable} />
            </div>
        );
    }
}

function getMergedReviewList(users) {
    var reviewList = [];
    users.forEach(user => {
        if (!user.reviews) return;
        reviewList = reviewList.concat(user.reviews);
    });
    reviewList.sort(function(a, b) { return b.createdAt.localeCompare(a.createdAt); });
    return reviewList;
}

function UserLoader(props) {
    const [user, setUser] = useState(null);

    useEffect(() => {
        api.getUser(props.id).then(setUser).catch(() => setUser(null));
    }, [props.id]);

    if(!user) {
        return <Fragment></Fragment>;
    }
    return (
        <Fragment>
            <User user={user}></User>
        </Fragment>
    );
}

function UserGroupLoader(props) {
    const [user, setUser] = useState(null);
    const [user2, setUser2] = useState(null);

    useEffect(() => {
        api.getUser(props.id).then(setUser).catch(() => setUser(null));
        api.getUser(props.id2).then(setUser2).catch(() => setUser2(null));
    }, [props.id, props.id2]);

    if(!user || !user2) {
        return <Fragment></Fragment>;
    }
    var mergedList = getMergedReviewList([user, user2]);
    return (
        <Fragment>
            <div style={{display: "inline-block"}}>
                <UserHeader user={user} showFavs={false} />
            </div>
            <div style={{display: "inline-block", marginLeft: "24px"}}>
                <UserHeader user={user2} showFavs={false} />
            </div>
            <UserReviewsHeader />
            <ItemReviewWithUserListItems itemReviews={mergedList} />
        </Fragment>
    );
}

class MeLoader extends React.Component {
    constructor() {
        super();
        this.state = { user: null };
        this.loadMe();
    }

    async loadMe() {
        try {
            await Auth.currentAuthenticatedUser();
            const user = await api.getMe();
            this.setState({ user });
        } catch (err) {
            console.warn("MeLoader: not signed in", err);
        }
    }

    render() {
        if (!this.state.user) {
            return <Fragment><div></div></Fragment>;
        }
        return <User user={this.state.user} editable={true} />;
    }
}


function ProfileLink(props) {
    return (
        <Fragment>
            <NavLink to={`/u/${props.userId}`} style={{display: "inline-block", overflow: "hidden", textOverflow: "ellipsis", verticalAlign: "bottom" }}>
                <ProfilePhotoLoader photo={props.profilePhoto} editable={false} size={props.size}></ProfilePhotoLoader>
            </NavLink>
        </Fragment>
    );
}


function ProfilePhotoLoader(props) {
    const [photo, setPhoto] = useState(props.photo);

    useEffect(() => {
        setPhoto(props.photo);
    }, [props.photo]);

    const handleSharePhoto = useCallback(
        (newPhotoKey) => {
            var nextPhoto = {
                key: newPhotoKey,
                width: 0,
                height: 0
            };
            api.updateMe({ photo: nextPhoto }).catch((err) => console.warn("updateMe failed", err));
            setPhoto(nextPhoto);
        },
        [],
    );
    var size = (props.size) ? props.size : "96";
    var sizePx = size + "px";
    return (
        <div style={{width: sizePx, height: sizePx, display: "inline-block", verticalAlign: "text-bottom"}}>
            <ProfilePhoto photo={photo} size={size}>
                <div style={{display: (props.editable) ? "block" : "none", alignSelf: "flex-end", zIndex: "1"}}>
                    <S3ImageUpload userId={props.userId} buttonText="Upload" handleShareImageConfirm={handleSharePhoto} />
                </div>
            </ProfilePhoto>
        </div>
    );
}

class ProfilePhoto extends React.PureComponent {
    render() {
        if(!this.props.photo || !this.props.photo.key) {
            return (
                <div style={{borderRadius: "50%", backgroundColor: "#AEABF2",
                width: (this.props.size) ? this.props.size + "px" : "96px", height: (this.props.size) ? this.props.size + "px" : "96px",
                display: "flex", justifyContent: "center"}}>
                    {this.props.children}
                </div>
            );
        }
        return (
            <div style={{backgroundImage: `url(${getCloudinaryUrlFromKey(this.props.photo.key, this.props.size*2, this.props.size*2, true)})`, backgroundSize: "contain",
            width: (this.props.size) ? this.props.size + "px" : "96px", height: (this.props.size) ? this.props.size + "px" : "96px", margin: 'auto', borderRadius: "50%",
            display: "flex", justifyContent: "center"}}>
                 {this.props.children}
            </div>
        );
    }
}


export { UserLoader, UserGroupLoader, MeLoader, ProfileLink };
